// Shared "within FOV" status colors, matching fov-stat-delta's convention:
// teal for a favorable/positive result, red-orange for unfavorable/negative.
export const COLOR_WITHIN_FOV = "#5EEAD4";
export const COLOR_OUT_OF_FOV = "#F97362";
